/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import { useSelector } from 'react-redux';

import { ContainerFull, Container, ContainerAlign } from './style';

import { Breadcumbs } from '~/components/Breadcumbs';
import { BackButton } from '~/components/BackButton';

const PerfilGeraisDosHospitais = () => {
  const { systemConfig } = useSelector(state => state.auth);

  const cpfUser = sessionStorage.getItem('cpf');

  const { urlSuperset } = systemConfig;

  const urlIframe = `${urlSuperset}/login/?username=${cpfUser}&redirect=/superset/dashboard/perfil_hospitalar/`;

  return (
    <>
      <ContainerFull>
        <div className="ContainerBreadcumbs">
          <Breadcumbs
            path="perfil-geral-dos-hospitais"
            pathTitle="Dashboard Perfil Hospitalar"
          />
          <ContainerAlign>
            <BackButton />
          </ContainerAlign>
        </div>
        <Container>
          <iframe
            id="frame"
            name="frame"
            title="SuperSet"
            src={urlIframe}
            frameBorder="0"
          />
        </Container>
      </ContainerFull>
    </>
  );
};

export default PerfilGeraisDosHospitais;
